import React from "react";
import { observer, inject } from "mobx-react";
import { FiltersCollapse, FilterCollapseWithButtonChange } from "ComponentsUI/Filters";
import { withRouter } from "react-router-dom";

@withRouter
@inject("ApplicationModel")
@observer
export default class CollapseFiltersContainer extends React.Component {
	constructor(props) {
		super(props);
		this.collapseFilters();
		this.state = {
			overflowForMobile: true,
		};
	}

	static defaultProps = {
		withoutResetButton: false,
		resetFiltersHandler: () => {},
	};

	componentWillUnmount() {
		this.collapseFilters();
	}

	uncollapseFilters() {
		let model = this.props.ApplicationModel.fixedPanelModel;
		model.uncollapseFilters();
		setTimeout(() => {
			this.setState({
				overflowForMobile: false,
			});
		}, 400);
	}

	collapseFilters() {
		let model = this.props.ApplicationModel.fixedPanelModel;
		model.collapseFilters();
		this.state &&
			this.setState({
				overflowForMobile: true,
			});
	}

	toggleFilters() {
		let model = this.props.ApplicationModel.fixedPanelModel;
		model.toggleFilters();
	}

	changeOpenState(value) {
		let model = this.props.ApplicationModel.fixedPanelModel;
		if (value) {
			model.hideFixedPanel();
		} else {
			model.showFixedPanel();
		}
	}

	render() {
		let model = this.props.ApplicationModel.fixedPanelModel;
		let text = this.props.ApplicationModel.text;
		let windowSizes = this.props.ApplicationModel.windowSizeModel.windowSizes;

		const Filter = this.props.showResetButtonAfterFilterApply
			? FilterCollapseWithButtonChange
			: FiltersCollapse;

		return (
			<Filter
				text={text}
				showFilters={model.filtersIsCollapsed}
				windowSizes={windowSizes}
				overflowForMobile={this.state.overflowForMobile}
				uncollapseFilters={() => this.uncollapseFilters()}
				collapseFilters={() => this.collapseFilters()}
				toggleFilters={() => this.toggleFilters()}
				resetFiltersHandler={this.props.resetFiltersHandler}
				withoutResetButton={this.props.withoutResetButton}
				changeOpenState={(value) => this.changeOpenState(value)}
				isProviderCard={this.props.isProviderCard}
				twoHiddenFilters={this.props.twoHiddenFilters}
				disableResetFilterButton={this.props.ApplicationModel.mobileFiltersTouchModel.haveFocus}
				showResetButtonAfterFilterApply={this.props.showResetButtonAfterFilterApply}
				haveUrlFilters={!!this.props.location.search}
			>
				{this.props.children}
			</Filter>
		);
	}
}
